import { ApiModule, type ApiResponse } from '@core';
import type { FormElementConfig } from '../';
import type { SelectSettings, SelectAttributes } from './select.model';

export type AutocompleteSettings = SelectSettings;

export interface AsyncAutocompleteSettings extends AutocompleteSettings {
  backendUrl?: string;
}

export type AutocompleteAttributes = SelectAttributes;

export type AutocompleteConfig = FormElementConfig<AutocompleteSettings, AutocompleteAttributes>;
export type AsyncAutocompleteConfig = FormElementConfig<AsyncAutocompleteSettings, AutocompleteAttributes>;

export abstract class AutocompleteApiModule extends ApiModule {
  public abstract search(endpoint: string, searchParams: any): Promise<ApiResponse<unknown>>;
}
